import { SizeType } from '../enumerations/cashier-preference-level';
import { CashierPreferences } from '../interfaces/dtos/CashierPreferences';
import { store } from '../redux/configure-store';
import { CashierPreferencesActions } from '../redux/reducers/cashier-preferences-reducer';
import { USER_DEFAULT_PREFERENCES } from './local-storage';

const setUserDefaults = (): void => {
  store.dispatch(
    CashierPreferencesActions.setCashierPreferences(
      USER_DEFAULT_PREFERENCES.accessibilityPreferences,
    ),
  );
};

const setUserPreferences = (userPreferences: CashierPreferences): void => {
  store.dispatch(CashierPreferencesActions.setCashierPreferences(userPreferences));
};

const isLeftHanded = (): boolean => {
  return store.getState().cashierPreferences.leftHanded;
};

const sizeMultiplier = (size: SizeType): number => {
  switch (size) {
    case SizeType.Large:
      return 1.25;
    case SizeType.Medium:
    default:
      return 1;
  }
};

const textSizeScalar = (): number => {
  const userPreferences = store.getState().cashierPreferences;
  const defaultScale = SizeType.Medium;
  if (userPreferences.textZoomLevel) {
    return sizeMultiplier(userPreferences.textZoomLevel);
  }
  return sizeMultiplier(defaultScale);
};

const CashierPreferencesHelper = {
  setUserDefaults,
  setUserPreferences,
  isLeftHanded,
  textSizeScalar,
  sizeMultiplier,
};

export default CashierPreferencesHelper;
